<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <upLevelRateAvg ref="playLevelCount" :typ="2" title="玩家升级速率分布" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <upLevelRateAvg ref="updateLevelCount" />
          </el-col>
        </el-row>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getPlayLevelStat, getUserLoginLevelStat } from '@/api/user/user_info'
import upLevelRateAvg from '@/views/config/up-level-stat/components/uplevel-level-num-stat.vue'
import { getLastDates, dateStrTodate, scientificFormat } from '@/utils'
export default {
  name: 'UpLevelCountStat',
  components: {
    upLevelRateAvg
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: [],
      levelData: [],
      headerData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }

    this.loading = true
    this.getTables()
    this.getPlayLevel()
    this.loading = false
  },
  methods: {
    dateStrTodate,
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.endDate) {
        this.msgError('请选择日期')
        return
      }
      this.getTables()
      this.getPlayLevel()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getUserLoginLevelStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.$refs.updateLevelCount.refresh(res.data)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getPlayLevel() {
      getPlayLevelStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.$refs.playLevelCount.refresh2(res.data)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
